import { InvestorType, InvestorTypeValue } from 'aem-libs-regular-investment/src/services/types'

import { CalcType } from '../model/enums'

export const parseTabFromString = (value: string, defaultValue: CalcType): CalcType => {
  const tabs = [CalcType.Amount, CalcType.Savings] as string[]
  return tabs.indexOf(value) !== -1 ? (value as CalcType) : defaultValue
}

export const parseInvestmentTypeFromString = (value: string): InvestorTypeValue | undefined => {
  const types = Object.keys(InvestorType)
  return types.indexOf(value) !== -1
    ? (InvestorType[value as keyof typeof InvestorType] as InvestorTypeValue)
    : undefined
}

export const validateMinMaxNumberValue = (value: number, min: number, max: number) => {
  if (value < min) {
    return min
  }

  if (value > max) {
    return max
  }

  return value
}
